import * as LucideIcons from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * A lucide component from the name a building configured on its utility button, falling back when the
 * name is absent or no longer exists in the library.
 *
 * Same resolver the tenant portal uses for its home cards, so a building's icon reads identically in both
 * places. The name is free text in the admin, so an unknown one has to degrade rather than throw.
 */
export const resolveLucideIcon = (iconName: string | null | undefined, fallbackIcon: LucideIcon): LucideIcon => {
  if (!iconName || !(iconName in LucideIcons)) {
    return fallbackIcon;
  }

  return LucideIcons[iconName as keyof typeof LucideIcons] as LucideIcon;
};
